// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1kYZz","footer":"ModalFilter_footer__3KLGS"};